import {
  RESET_GENERAL_STATE,
  SET_GENERAL_CONFIG,
  SET_IS_POPOVER_CHAT_OPEN,
  DEFAULT_OPEN_POPOVER_CHAT,
  OPEN_POPOVER_ON_CLICKTRHOUGH,
  ADD_PAYWALL,
  SET_IS_PAID_USER,
  SET_SHOW_SEND_CHAT_MODAL,
} from './constants'
import initialState from './state'
import { getLastPartOfUrl } from '../../utils/helpers'
import cloneDeep from 'lodash.clonedeep'
import cookie from 'react-cookies'

const setConfig = (state, action) => {
  const newState = cloneDeep(state)

  newState.organizationSlug = action.payload.organizationSlug
  newState.organizationKey = action.payload.organizationKey
  newState.language = action.payload.language
  newState.widgetMode = action.payload.widgetMode
  newState.introType = action.payload.introType // INTRO TYPE FOR DEFAULT MESSAGES
  newState.chatMode = action.payload.chatMode

  // ITS A ORGANIZATION CLIENT CHAT
  // GET SLUG OF CLIENT FROM URL
  if (action?.payload?.chatMode === 'b2b') {
    let clientSlug = getLastPartOfUrl()
    newState.organizationClientSlug = clientSlug
  }

  return newState
}

const setOpenPopoverOnClickthrough = (state, action) => {
  const newState = cloneDeep(state)
  newState.openPopoverChatOnClickthrough = action.payload
  return newState
}

const autoOpenPopoverChat = (state, action) => {
  const newState = cloneDeep(state)

  newState.isPopoverChatOpen = true
  newState.autoOpenPopoverChat = false

  return newState
}

const setIsPopoverChatOpen = (state, action) => {
  const newState = cloneDeep(state)

  newState.isPopoverChatOpen = action.payload

  // DONOT OPEN POPOVER BY DEFAULT AFTER 30 SECONDS IF USER HAS ALREADY OPEN/CLOSED IT
  newState.autoOpenPopoverChat = false

  if (newState.isPopoverChatOpen) {
    // SET IN COOKIE THAT POPOVER CHAT IS CURRENTLY OPEN
    cookie.save(
      `maya_is_popover_chat_open_${process.env.REACT_APP_API_ENV}`,
      'true',
      { path: '/', maxAge: 3600, domain: window.location.hostname }
      // MAINTAIN THIS COOKIE I.E. CHAT OPENING STATE FOR 1 HR I.E. 3600 SECONDS
    )
  } else {
    // REMOVE POPOVER CHAT OPEN CASE FROM COOKIE
    cookie.remove(
      `maya_is_popover_chat_open_${process.env.REACT_APP_API_ENV}`,
      { path: '/', domain: window.location.hostname }
    )
  }

  return newState
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_GENERAL_STATE:
      return { ...initialState }
    case SET_GENERAL_CONFIG:
      return setConfig(state, action)
    case SET_IS_POPOVER_CHAT_OPEN:
      return setIsPopoverChatOpen(state, action)
    case OPEN_POPOVER_ON_CLICKTRHOUGH:
      return setOpenPopoverOnClickthrough(state, action)
    case DEFAULT_OPEN_POPOVER_CHAT:
      return autoOpenPopoverChat(state, action)
    case ADD_PAYWALL:
      return { ...state, limitMessagesCase: action.payload }
    case SET_IS_PAID_USER:
      return { ...state, userByPassMessagesLimit: action.payload }
    case SET_SHOW_SEND_CHAT_MODAL:
      return { ...state, showSendChatModal: action.payload }
    default:
      return state
  }
}

export default reducer
